import { Component, input, output } from "@angular/core";

@Component({
  selector: "app-collapse-content",
  standalone: true,
  imports: [],
  templateUrl: "./collapse-content.component.html",
  styleUrl: "./collapse-content.component.scss",
})
export class CollapseContentComponent {
  showConetnt = false;

  readonly title = input.required<string>();
  readonly customClass = input("", { alias: "class" });
  readonly withBoxShadow = input(false);
  readonly autoOpen = input(false);

  readonly collapsed = output<boolean>(); // if you want to do an event after collapsed

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.autoOpen()) this.collapse();
  }

  collapse() {
    this.showConetnt = !this.showConetnt;
    this.showCollapsed();
    this.collapsed.emit(this.showConetnt);
  }

  private showCollapsed() {
    setTimeout(() => {
      const accordions = document.querySelectorAll(".accordion-wrapper");

      const openAccordion = (accordion: HTMLElement) => {
        accordion.style.height = accordion.scrollHeight + "px";
      };

      const closeAccordion = (accordion: HTMLElement) => {
        accordion.style.height = "0";
      };

      const observeContentChanges = (accordion: HTMLElement) => {
        const observer = new MutationObserver(() => {
          // Recalculate the height when content changes
          accordion.style.height = accordion.querySelector(".content-wrapper")?.scrollHeight + "px";
        });

        observer.observe(accordion, {
          childList: true, // Observe direct child changes
          subtree: true, // Observe changes within descendants
          characterData: true, // Observe changes in text content
        });
      };

      accordions.forEach((accordion) => {
        const showContent = accordion.querySelector(".showContent") as HTMLElement;
        const content = accordion.querySelector(".contentCollapsed") as HTMLElement;

        if (content) {
          if (showContent) {
            openAccordion(content);
            observeContentChanges(content); // Start observing for content changes
          } else {
            closeAccordion(content);
          }
        }
      });
    });
  }
}
